import I18n from '../../config/locales';

const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Installer NPS'
  },
  {
    id: 'SystemName',
    numeric: true,
    disablePadding: false,
    label: 'System Name'
  },
  { id: 'Comments', numeric: true, disablePadding: false, label: 'Comments' }
];

const npsScore = (ratings, ratingsList) => {
  if (ratingsList === []) {
    return;
  }

  const {
    zeroRatingsCount,
    oneRatingsCount,
    twoRatingsCount,
    threeRatingsCount,
    fourRatingsCount,
    fiveRatingsCount,
    sixRatingsCount,
    sevenRatingsCount,
    eightRatingsCount,
    nineRatingsCount,
    tenRatingsCount
  } = ratings;

  let npsScoreData = [];

  return (npsScoreData = [
    ...npsScoreData,
    {
      name: 'Detractors',
      y:
        zeroRatingsCount +
        oneRatingsCount +
        twoRatingsCount +
        threeRatingsCount +
        fourRatingsCount +
        fiveRatingsCount +
        sixRatingsCount,
      percentage:
        (zeroRatingsCount +
          oneRatingsCount +
          twoRatingsCount +
          threeRatingsCount +
          fourRatingsCount +
          fiveRatingsCount +
          sixRatingsCount) /
        (zeroRatingsCount +
          oneRatingsCount +
          twoRatingsCount +
          threeRatingsCount +
          fourRatingsCount +
          fiveRatingsCount +
          sixRatingsCount +
          sevenRatingsCount +
          eightRatingsCount +
          nineRatingsCount +
          tenRatingsCount),
      color: '#E64441'
    },
    {
      name: 'Passive',
      y: sevenRatingsCount + eightRatingsCount,
      percentage:
        (sevenRatingsCount + eightRatingsCount) /
        (zeroRatingsCount +
          oneRatingsCount +
          twoRatingsCount +
          threeRatingsCount +
          fourRatingsCount +
          fiveRatingsCount +
          sixRatingsCount +
          sevenRatingsCount +
          eightRatingsCount +
          nineRatingsCount +
          tenRatingsCount),
      color: '#FED24D'
    },
    {
      name: 'Promoters',
      y: nineRatingsCount + tenRatingsCount,
      percentage:
        (nineRatingsCount + tenRatingsCount) /
        (zeroRatingsCount +
          oneRatingsCount +
          twoRatingsCount +
          threeRatingsCount +
          fourRatingsCount +
          fiveRatingsCount +
          sixRatingsCount +
          sevenRatingsCount +
          eightRatingsCount +
          nineRatingsCount +
          tenRatingsCount),
      color: '#52C554'
    }
  ]);
};
const npsSpread = (ratings, ratingsList) => {
  if (ratingsList === []) {
    return;
  }
  const {
    zeroRatingsCount,
    oneRatingsCount,
    twoRatingsCount,
    threeRatingsCount,
    fourRatingsCount,
    fiveRatingsCount,
    sixRatingsCount,
    sevenRatingsCount,
    eightRatingsCount,
    nineRatingsCount,
    tenRatingsCount
  } = ratings;

  var tempsum =
    zeroRatingsCount +
    oneRatingsCount +
    twoRatingsCount +
    threeRatingsCount +
    fourRatingsCount +
    fiveRatingsCount +
    sixRatingsCount +
    sevenRatingsCount +
    eightRatingsCount +
    nineRatingsCount +
    tenRatingsCount;
  let npsSpreadData = [];
  return (npsSpreadData = [
    ...npsSpreadData,
    {
      name: '0',
      y: zeroRatingsCount,
      color: '#E64441',
      percentage: zeroRatingsCount * 100 / tempsum
    },
    { name: '1', y: oneRatingsCount, color: '#E64441', percentage: oneRatingsCount * 100 / tempsum },
    { name: '2', y: twoRatingsCount, color: '#E64441', percentage: twoRatingsCount * 100 / tempsum },
    {
      name: '3',
      y: threeRatingsCount,
      color: '#E64441',
      percentage: threeRatingsCount * 100 / tempsum
    },
    {
      name: '4',
      y: fourRatingsCount,
      color: '#E64441',
      percentage: fourRatingsCount * 100 / tempsum
    },
    {
      name: '5',
      y: fiveRatingsCount,
      color: '#E64441',
      percentage: fiveRatingsCount * 100 / tempsum
    },
    { name: '6', y: sixRatingsCount, color: '#E64441', percentage: sixRatingsCount * 100 / tempsum },
    {
      name: '7',
      y: sevenRatingsCount,
      color: '#FED24D',
      percentage: sevenRatingsCount * 100 / tempsum
    },
    {
      name: '8',
      y: eightRatingsCount,
      color: '#FED24D',
      percentage: eightRatingsCount * 100 / tempsum
    },
    {
      name: '9',
      y: nineRatingsCount,
      color: '#52C554',
      percentage: nineRatingsCount * 100 / tempsum
    },
    {
      name: '10',
      y: tenRatingsCount,
      color: '#52C554',
      percentage: tenRatingsCount * 100 / tempsum
    }
  ]);
};

const npsScoreNumber = (ratings, ratingsList) => {
  if (ratingsList === []) {
    return;
  }
  const {
    zeroRatingsCount,
    oneRatingsCount,
    twoRatingsCount,
    threeRatingsCount,
    fourRatingsCount,
    fiveRatingsCount,
    sixRatingsCount,
    sevenRatingsCount,
    eightRatingsCount,
    nineRatingsCount,
    tenRatingsCount
  } = ratings;

  var tempsum =
    zeroRatingsCount +
    oneRatingsCount +
    twoRatingsCount +
    threeRatingsCount +
    fourRatingsCount +
    fiveRatingsCount +
    sixRatingsCount +
    sevenRatingsCount +
    eightRatingsCount +
    nineRatingsCount +
    tenRatingsCount;
  let npsScore = ((nineRatingsCount +
    tenRatingsCount -
    (zeroRatingsCount +
      oneRatingsCount +
      twoRatingsCount +
      threeRatingsCount +
      fourRatingsCount +
      fiveRatingsCount +
      sixRatingsCount)) *
    100 /
    tempsum).toFixed(0);
  npsScore = isNaN(npsScore) ? '--' : npsScore;
  return npsScore;
};

const npsTypeFunction = () => {
  return {
    promoter: I18n.t('nps.promoter'),
    detractor: I18n.t('nps.detractor'),
    passive: I18n.t('nps.passive')
  };
};

export { npsScore, npsSpread, npsScoreNumber, headCells, npsTypeFunction };
